import { faBox, faArrowsTurnToDots, faComment, faFlask, faMagnifyingGlass, faMessage, faNoteSticky, faTimeline, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { use, useContext, useEffect, useState, useMemo } from 'react';
import { Accordion, Spinner } from 'react-bootstrap';

import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import { UserPreferencesContext } from '../../../Contexts/UserPreferencesContext';
import { QualityColumnType } from '../../../Types/LotDetailQuality';
import { Section } from '../../../Types/Section';
import CommentsSection from '../LotDetailsComponents/CommentsSection';
import GenealogySection from '../LotDetailsComponents/GenealogySection';
import GradingCommentsSection from '../LotDetailsComponents/GradingCommentsSection';
import LabResultsSection from '../LotDetailsComponents/LabResultsSection';
import QIRSection_QIRMS from '../LotDetailsComponents/QIRSection_QIRMS';
import QualitiesSection from '../LotDetailsComponents/QualitiesSection';
import BatchesSection from '../LotDetailsComponents/BatchesSection';
import PackoutSection from '../LotDetailsComponents/PackoutSection';
import LotDetailSummary from '../LotDetailsComponents/Summary';
import WarningsSection from '../LotDetailsComponents/WarningsSection';
import { LotDetailSection } from '../LotDetailSection';
import { SectionNavigation } from '../SectionNavigation';

function LotDetails_BRPP() {
    const { lotDetail } = useContext(LotDetailContext);
    const { userPreferences, loading: userPreferencesLoading, setActiveSections } = use(UserPreferencesContext);
    const [loading, setLoading] = useState(false);

    const qualityTableColumns: QualityColumnType[] = useMemo(() => [
        'Name',
        'Primary',
        'QualityValueConfidence',
        'Secondary',
        'Manual',
        'L3Lab',
        'LBMLab',
        'LBMSecondaryLab',
        'Min',
        'Target',
        'Max',
        'Units',
        'SelectUsedValue',
        'displayOrder'
    ], []);

    const sections: Section[] = [
        { name: 'warnings', title: 'LotDetails.Warnings.Title', titleSuffix: `${lotDetail.warnings?.length}`, icon: faTriangleExclamation, component: <WarningsSection /> },
        { name: 'QIRMSqirs', title: 'LotDetails.QIRs.Title', titleSuffix: `${lotDetail.qirs?.length}`, icon: faNoteSticky, component: <QIRSection_QIRMS showCreateQIRButton={true} /> },
        { name: 'packouts', title: 'LotDetails.Packouts.Title', titleSuffix: `${lotDetail.packouts?.length}`, icon: faBox, component: <PackoutSection /> },
        { name: 'batches', title: 'LotDetails.Batches.Title', titleSuffix: `${lotDetail.batches?.length}`, icon: faArrowsTurnToDots, component: <BatchesSection /> },
        { name: 'qualities', title: 'LotDetails.Qualities.Title', titleSuffix: `${lotDetail.qualities?.length}`, icon: faMagnifyingGlass, component: <QualitiesSection customQualityColumns={qualityTableColumns} /> },
        { name: 'labresults', title: 'LotDetails.LabResults.Title', titleSuffix: `${lotDetail.labResults.length}`, icon: faFlask, component: <LabResultsSection isRailCarSite={true} /> },
        { name: 'genealogy', title: 'LotDetails.Genealogy.Title', icon: faTimeline, component: <GenealogySection /> },
        { name: 'gradingcomments', title: 'LotDetails.GradingComments.Title', icon: faComment, component: <GradingCommentsSection /> },
        { name: 'comments', title: 'LotDetails.Comments.Title', icon: faMessage, component: <CommentsSection /> },
    ];

    const [defaultActiveSections, setDefaultActiveSections] = useState(sections.map(section => section.name));
    useEffect(() => {
        if (userPreferences?.lotDetail?.activeSections) {
            setDefaultActiveSections(userPreferences?.lotDetail?.activeSections);
        }
    }, [userPreferences?.lotDetail?.activeSections]);

    if (userPreferencesLoading) {
        return (
            <div className="d-flex justify-content-center mb-3">
                <Spinner animation="border" />
            </div>
        );
    }

    return (lotDetail && defaultActiveSections &&
        <>
            <LotDetailSummary setLoading={setLoading} />

            <SectionNavigation sections={sections} />

            <Accordion activeKey={defaultActiveSections} onSelect={(eventKey) => setActiveSections(eventKey as string[])} alwaysOpen className="mb-2">
                {sections.map(section =>
                    <LotDetailSection
                        key={section.name}
                        name={section.name}
                        icon={section.icon}
                        title={section.title}
                        titleSuffix={section.titleSuffix}
                        component={section.component} />)
                }
            </Accordion>
        </>
    );
}

export default LotDetails_BRPP;